svg{width:20rem}
/*# sourceMappingURL=splits-diagram.component-WVXGDCXF.css.map */
